<template lang="pug">
  div(
  @click="showColorPallet=false"
  ).geo.apo-update.without-tabs
    e-form-modal(
    @submitModalForm="sendForm()"
    @deleteItem="deleteItem()"
    :hideDeleteButton="(!!fields.id)"
    )
      div(slot="header")
        e-breadcrumbs
        h1.title
          template(v-if="fields && fields.id") {{fields.name}}
          template(v-else) Добавление новой зоны деятельности
      slot
        e-form(:formValidator="formValidator")
          div(v-show="tabView === 'tab1'")
            div.body
              div.col
                e-form-group(
                name="name"
                inputType="input"
                label="Наименование"
                :model="fields"
                :required="true"
                tabView="tab1"
                )
                e-form-group(
                  name="is_active"
                  inputType="select"
                  label="Активный"
                  :model="fields"
                  :required="true"
                  tabView="tab1",
                  :options="yesOrNo"
                )
                e-form-group(
                name="color"
                label="Цвет"
                :model="fields"
                tabView="tab1"
                :required="true"
                )
                  slot
                    div.color-chooser
                      div(
                      @click.stop.prevent="showColorPallet=!showColorPallet"
                      :style="{'background-color': fields.color}"
                      ).color-preview
                      button(
                      @click.stop.prevent="showColorPallet=!showColorPallet"
                      ).actions-filter-panel__button.color-select-btn {{showColorPallet ? 'Скрыть палитру' : 'Выбор цвета'}}
                    div(
                    @click.stop.prevent=""
                    ).color-pallet
                      chrome(
                      v-if="showColorPallet"
                      v-model="fields.colorObject"
                      @input="updateColor"
                      :disableAlpha="true"
                      )
                e-form-group(
                name="tko_operator_id"
                label="Региональный оператор"
                :model="fields"
                tabView="tab1"
                :required="true"
                ).apo-form-group
                  div(slot="label")
                  slot
                    div
                      div.table-choose-panel
                        div.toolbar-table
                          div.select Региональный оператор*
                          div.toolbar.toolbar--modal
                            div.line
                              div.actions-panel
                                e-button-edit(@click="showTkoOperatorSelectTable=!showTkoOperatorSelectTable")

                        div.table
                          table
                            thead
                              th Наименование
                              //th ИНН
                              //th Юр. адрес
                              //th Местоположение
                              //th Код в кадастре
                              //th № лицензии
                              //th Срок действия
                              th
                            tbody
                              tr(v-if="fields.tkoOperator")
                                td(v-html="fields.tkoOperator.name || ' - '")
                                //td {{fields.tkoOperator.inn}}
                                //td {{fields.tkoOperator.address}}
                                //td {{fields.tkoOperator.fact_address}}
                                //td {{fields.tkoOperator.cadastr_code}}
                                //td {{fields.tkoOperator.license_number}}
                                //td {{fields.tkoOperator.license_start_date ? 'с ' + fields.tkoOperator.license_start_date : ''}} {{fields.tkoOperator.license_finish_date ? 'по ' + fields.tkoOperator.license_finish_date : ''}}
                                td
                                  e-button-delete(@click="deleteTkoOperator")
                              tr(v-else)
                                td(colspan=100) Региональный оператор не указан
                e-modal(
                v-if="showTkoOperatorSelectTable"
                @close="showTkoOperatorSelectTable = false"
                @confirm="saveTkoOperator"
                title="Выбор оператора"
                )
                  slot
                    e-table-checked-list(
                    selectType="radio"
                    ref="tkoOperatorSelectTable"
                    @checkedChange="tkoOperatorUpdate"
                    :endpoint="endpointTkoOperatorList"
                    :earlyCheckedItems="getEarlyCheckedTkoOperator"
                    :showPaginate="true"
                    )

              div.col
                div.toolbar.toolbar--modal
                  div.line
                    div.parameters
                      div.actions-panel
                        e-button-add(
                        @click="addNewRow")
                div(slot="label")
                slot
                  e-table-editable(
                  ref="tariff"
                  :attributes="tariffAttr"
                  :dataUrl="tariffDataUrl"
                  :postUrl="tariffPostUrl"
                  :patchUrl="tariffPatchUrl"
                  :deleteUrl="tariffDeleteUrl"
                  :tableInOnlineMode="tableInOnlineMode"
                  :defaultColumnWidth="25"
                  :tableHeight="270"
                  )
                    template(v-slot:year="{model}")
                      e-select(
                        :disabled="model.id > 0"
                        name="year"
                        :model="model"
                        :options="availableYears[model.id || model._storeUUID]"
                      )

            div.body
              div.col
                municipalities(
                  ref="tkoOperator"
                  :fields="fields"
                  :apo="true"
                  @saved="municipalitiesUpdated"
                  @delete="municipalitiesUpdated"
                )


</template>
<style>
  .e-button-add.actions-panel__button.btn-add.green{
    margin: 0.5rem;
  }
</style>
<script>
  import {map, tko} from '../../api/api-endpoints.js'
  import apoForm from './mixins/apo-form.js'
  import {Chrome} from 'vue-color'
  import Municipalities from "../registry/components/municipalities";
  import formBaseMixin from '../../components/form/form-base-mixin.js'

  export default {
    mixins: [apoForm],
    components: {Municipalities, Chrome},
    data() {
      return {
        tabView: 'tab1',
        fields: {
          name: '',
          color: '',
          mos: [],
        },
      }
    },
    computed: {
      tariffDataUrl() { return map.apoTariff(this.$route.params.id) },
      tableInOnlineMode() { return !!this.$route.params.id },
      tariffAttr() {
        return {
          value: {
            label: 'Прогнозное значение предельного тарифа (руб.)',
            placeholder: 0.00,
            validationRulePattern: '^([0-9]{1,}\\.{1}[0-9]{2})$',
            invalidMessage: 'Укажите число, 2 знака после точки',
            required: true,
          },
          year: {
            label: 'Период регулирования (год)',
            validationRulePattern: '(\\.*)',
            required: true,
            transform: m => m.year,
          }
        }
      },
      yesOrNo() { return [ {id: 0, name: 'Нет'}, {id: 1, name: 'Да'} ] },
    },
    methods: {
      getItemOperatorEndpoint (tkoOpId) { return tko.operator(tkoOpId) },
      onSuccess () {
        if (this.onlyUpdate === true) {
          this.onlyUpdate = false
        } else {
          formBaseMixin.methods.onSuccess.call(this)
        }
      },
      innerUpdated () {
        if (this.fields.id) {
          this.onlyUpdate = true
          this.sendForm()
        }
      },
      addNewRow() {
        const Model = (id) => ({ year: '', value: '', apo_id: id || '' })

        this.$refs.tariff.createRow(new Model(this.$route.params.id))
      },
      getDeleteUrl(id) { return map.apoDelete(id) },
      getUpdateOrCreateUrl() { return map.apo(this.$route.params.id) },
      getItemEndpoint(route) { return route.params?.id ? map.apo(route.params.id) : null },
      tariffPostUrl(context, model) { return map.apoTariff(this.$route.params.id) },
      tariffPatchUrl(context, model) { return map.apoTariffPatch(model.id) },
      tariffDeleteUrl(context, model) { return map.apoTariffDelete(model.id) },
      async afterSave(response) {
        if (this.$route.params.id) {
          return
        }
        const endpoint = map.apoTariff
        let tariffData = this.$store.getters.readUrlEndpoint(endpoint())?.data
        if (!tariffData) {
          return
        }
  
        let promises = []
  
        let newTariff = tariffData.filter(item => !item.apo_id)
        if (response?.data?.id) {
          promises.push(this.$store.dispatch('createModel', {
            url:  endpoint(response.data.id),
            data: newTariff
          }))
          await Promise.all(promises).then(() => {
            this.$store.commit('setEndpointData', { endpoint: endpoint(), data: { data: [] } })
          })
          return Promise.resolve(1)
        }
      }
    }
  }
</script>
